// extracted by mini-css-extract-plugin
export default {"card":"Card_card__GIi61","container":"Card_container__WeLyh","title":"Card_title__UUpdO","description":"Card_description__U5HRX","button":"Card_button__U2Np4"};